<template>
  <div id="app-user-settings-body">
    <div id="app-user-settings-title">
      <h1 id="app-user-settings-title-h">设置</h1>
    </div>
    <div id="app-user-settings-content-body">
      <div class="app-user-settings-content">
        <div class="app-user-settings-content-name">修改密码</div>
        <div class="app-user-settings-content-detail"></div>
        <el-button class="app-user-settings-button" v-on:click="$refs.ChangePassword.dialogFormVisible = true">修改
        </el-button>
      </div>
      <div class="app-user-settings-content">
        <div class="app-user-settings-content-name">修改手机</div>
        <div class="app-user-settings-content-detail"></div>
        <el-button class="app-user-settings-button" disabled>修改</el-button>
      </div>
      <div class="app-user-settings-content">
        <div class="app-user-settings-content-name">退出登录</div>
        <div class="app-user-settings-content-detail"></div>
        <el-button class="app-user-settings-button" v-on:click="logout">退出登录</el-button>
      </div>
    </div>
    <ChangePassword ref="ChangePassword"></ChangePassword>
  </div>
</template>

<script>
import ChangePassword from "@/views/user/center/adviceSettings/ChangePassword";
import DataStorePersisted from "@/components/dataStorePersisted";
import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";

export default {
  name: "AdviceSettings",
  components: {
    ChangePassword
  },
  methods: {
    logout() {
      DataStorePersisted.state.isLogin = false;
      AxiosBase.axiosGet("/user/logout", {}).then(response => {
        if (response !== 0) {
          this.$router.push("/login");
          Message({
            showClose: true,
            message: '成功退出登录',
            type: 'success'
          });
        }
      })
    },
  }
}
</script>

<style scoped>


#app-user-settings-body {
  /*border: 1px solid #000000;*/
  padding: 25px;
}

#app-user-settings-title {
  padding-bottom: 25px;
  border-bottom: 1px solid rgba(20, 20, 20, 0.2);
}

#app-user-settings-title-h {
  font-size: 16px;
}

#app-user-settings-content-body {
  position: relative;
  padding-top: 25px;
  padding-left: 10px;
}

.app-user-settings-content {
  position: relative;
  margin-left: 25px;
  margin-top: 25px;
  height: 61px;
}

.app-user-settings-content-name {
  height: 60px;
  width: 120px;
  line-height: 60px;
  /*text-align: center;*/
  padding-left: 25px;
  float: left;
}

.app-user-settings-content-detail {
  position: relative;
  top: 0;
  left: 0;
  height: 60px;
  width: 630px;
  /*border-bottom: 1px solid rgba(20, 20, 20, 0.2);*/
  text-align: left;
  line-height: 60px;
  padding-left: 150px;
  background: rgba(20, 20, 20, 0.1);
}

.app-user-settings-button {
  position: absolute;
  right: 50px;
  top: 10px;
  border: 0;
  border-radius: 0;
  background: #FF8A00;
  color: #FFFFFF;
}

.app-user-settings-button:hover {
  transition: all 300ms ease-out;
  background: #00aa55;
}

</style>